import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router } from '@angular/router';

import { LANDING_ROUTE, LOGIN_ROUTE } from './auth.paths';
import { SessionToken } from './session-token';

/**
 * Both guards key on the token rather than on AuthStore status: the token is
 * the single source of truth that survives a reload, and it is what the API
 * will actually accept.
 */
export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  return inject(SessionToken).hasValidToken() || router.createUrlTree([LOGIN_ROUTE]);
};

export const publicGuard: CanActivateFn = () => {
  const router = inject(Router);
  return inject(SessionToken).hasValidToken() ? router.createUrlTree([LANDING_ROUTE]) : true;
};

/**
 * Shell selector for routes that exist in both shells (the 404 page).
 *
 * `CanMatchFn`, not `CanActivateFn`, on purpose: a false result makes the
 * router skip the branch and keep matching, so the public branch picks the
 * navigation up instead of the visitor being redirected to login.
 */
export const authenticatedMatch: CanMatchFn = () => inject(SessionToken).hasValidToken();
